export default __webpack_public_path__ + "static/media/chicago_regatta_cup.18c0e671.png";